export function Months(monthNumber = 12) {
  const months: number[] = [];
  for (let i = 1; i <= monthNumber; i += 1) months.push(i);

  return months;
}
